// src/components/Navbar.js
import React, { useState, useEffect, useCallback } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import "../index.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((v) => !v), []);

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Empêche le scroll derrière le menu quand il est ouvert (mobile)
  useEffect(() => {
    document.body.classList.toggle("nav-open", open);
    return () => document.body.classList.remove("nav-open");
  }, [open]);

  // Ferme au clavier (ESC)
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMenu();
    };

    if (open) window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, closeMenu]);

  // Mailto CTA
  const buildAvailabilityMailto = () => {
    const to = "contact@hlbk.fr";
    const subject = "Parler de votre projet";
    const body = [
      "Bonjour Maxime,",
      "",
      "Je souhaite échanger avec vous à propos d’un projet :",
      "",
      "• Type de prestation :",
      "• Date / période souhaitée :",
      "• Lieu :",
      "• Besoin / objectif :",
      "• Nom :",
      "• Téléphone :",
      "",
      "Merci !",
      "— Envoyé depuis hlbk.fr",
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <nav
      className="navbar nav-centered"
      role="navigation"
      aria-label="Navigation principale"
    >
      {/* Logo */}
      <div className="navbar-logo-wrap">
        <Link
          to="/"
          className="navbar-logo"
          aria-label="Accueil"
          onClick={closeMenu}
        >
          <img
            src="/images/logo.png"
            alt="HLBK"
            width="120"
            height="120"
            decoding="async"
            fetchPriority="high"
          />
        </Link>
      </div>

      {/* Burger */}
      <button
        className={`nav-burger ${open ? "is-open" : ""}`}
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={open}
        aria-controls="navmenu"
        onClick={toggleMenu}
      >
        <span className="burger-bar" />
        <span className="burger-bar" />
        <span className="burger-bar" />
      </button>

      {/* Menu */}
      <div id="navmenu" className={`navbar-menu ${open ? "open" : ""}`}>
        <NavLink
          to="/"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : undefined)}
          end
        >
          Accueil
        </NavLink>

        <NavLink
          to="/services"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Prestations
        </NavLink>

        <NavLink
          to="/galerie"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Galerie
        </NavLink>

        <NavLink
          to="/about"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          À propos
        </NavLink>

        <NavLink
          to="/contact"
          onClick={closeMenu}
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Contact
        </NavLink>

        <a
          href={buildAvailabilityMailto()}
          className="nav-cta"
          onClick={closeMenu}
        >
          Parler de votre projet
        </a>

        <div className="nav-sep" aria-hidden="true" />

        <NavLink
          to="/acces-clients"
          onClick={closeMenu}
          className={({ isActive }) =>
            isActive ? "active nav-muted" : "nav-muted"
          }
        >
          Accès clients
        </NavLink>
      </div>

      {/* Backdrop mobile */}
      {open && (
        <div
          className="nav-backdrop"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
    </nav>
  );
}